import { render } from "./IconBackArrowPulldown.vue?vue&type=template&id=7b54e05c&scoped=true"
const script = {}

import "./IconBackArrowPulldown.vue?vue&type=style&index=0&id=7b54e05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b54e05c"]])

export default __exports__